/**
 * @file Open `external` links in safe new window.
 * @author Gonzalo Alvarez de Aldecoa <gon@galdecoa.com>
 * @license GPL-3.0-or-later
 * @version 2309.27.001
 */

/** @module externallinkshandler */

/**
 * Handles the `click` event of an anchor, opening its `href` in a new window,
 * with `noopener` and `noreferrer`.
 * @param {Event} clickEvent A `click` event on an anchor (`a`) element.
 */
function onExternalLinkClick( clickEvent ) {
	clickEvent.preventDefault();
	let anchor = clickEvent.target;
	while( anchor && ( anchor.tagName.toLowerCase() != "a" ) ) {
		anchor = anchor.parentElement;
	}
	if ( !anchor ) { return; }
	window.open( anchor.href, "_blank", "noopener=1,noreferrer=1" );
}

/**
 * Binds `{@link module:externallinkshandler~onExternalLinkClick}` to all 
 * anchors within `element` that have a `rel` attribute with `external`.
 * @param {HTMLElement} element 
 */
export function handleExternalLinks( element ) {
	const externalLinks = element.querySelectorAll( "a[rel*=external]" );
	for ( let l = externalLinks.length - 1; l >= 0; l = l - 1 ) {
		externalLinks[ l ].addEventListener( "click", onExternalLinkClick );
	}
}